<ng-container *ngIf="shouldShowErrors()">
  <div class="validation-error" *ngFor="let error of listOfErrors()">
    <strong>{{error.message | translate:error.payload}}</strong>
  </div>
</ng-container>
